import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { FeatureId } from '../core/client/features.gen'
import { useFeatures } from '../core/features/FeaturesProvider'

interface FeatureRouteProps {
  feature: FeatureId
  children: ReactNode
  redirectTo?: string
}

/** Route guard: a disabled feature's pages redirect instead of rendering. */
export const FeatureRoute: React.FC<FeatureRouteProps> = ({ feature, children, redirectTo = '/' }) => {
  const { isEnabled } = useFeatures()

  if (!isEnabled(feature)) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
